import AuthApi from '../shared/api/AuthApiService';
import { Auth } from '../shared/storage/StorageKeys';
import StorageService from '../shared/storage/StorageService';
import Jwt from '../shared/utilities/Jwt';

const LoginService = {
    
    Authenticate: async (username: string, password: string) => {
        try {
            const response = await AuthApi.getToken(username, password);

            await StorageService.set(Auth.Token, response);
            const decodedToken = Jwt.Decode(response);
            await StorageService.set(
                Auth.FirstName,
                decodedToken.FirstName
            );
            await StorageService.set(
                Auth.LastName,
                decodedToken.LastName
            );
            await StorageService.set(
                Auth.Role,
                decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role']
            );
            await StorageService.set(
                Auth.Id,
                decodedToken.Id
            );
            await StorageService.set(
                Auth.Email,
                decodedToken.Email
            );
            return true;
        } catch (error) {
            console.log('error', error);
            return false;
        }
    },
};

export default LoginService;
